module.exports = {"create_energetic_inform":"Crear Informe Energetic","date_range":"Rang de dates","create":"Crear","energetic_inform":"Informe Energetic"}


//////////////////
// WEBPACK FOOTER
// ./src/translates/cat/EnergeticInform.json
// module id = 586
// module chunks = 1